/** Shared SAMS HTTP client timeout for webapp server functions and match loading. */
export const SAMS_API_TIMEOUT_MS = 10_000;

/** DynamoDB match cache TTL — keep useSamsMatches staleTime aligned with this. */
export const SAMS_MATCHES_CACHE_TTL_MS = 5 * 60 * 1000;
